import type { MouseEvent } from "react"

/**
 * Material-style press ripple (ported from v1-ui): spawns an expanding
 * circle at the press point. Reusable by ANY interactable element — call
 * from onMouseDown; the host needs `position: relative` and
 * `overflow: hidden` (the .bo-button base carries both) plus the
 * .bo-ripple styles from button.css.
 */
export function createRipple(event: MouseEvent<HTMLElement>) {
  const host = event.currentTarget

  const diameter = Math.max(host.clientWidth, host.clientHeight)
  const radius = diameter / 2

  const circle = document.createElement("span")
  circle.className = "bo-ripple"
  circle.style.width = circle.style.height = `${diameter}px`

  const { top, left } = host.getBoundingClientRect()
  circle.style.left = `${event.clientX - left - radius}px`
  circle.style.top = `${event.clientY - top - radius}px`

  // One ripple at a time; a re-press replaces the previous circle.
  host.querySelector(".bo-ripple")?.remove()
  host.appendChild(circle)

  // animationend is the normal cleanup; the timeout covers environments
  // where the animation never runs (e.g. prefers-reduced-motion).
  circle.addEventListener("animationend", () => circle.remove())
  setTimeout(() => circle.remove(), 600)
}
